import { render, staticRenderFns } from "./reservoir_area.vue?vue&type=template&id=19e4b5f2&scoped=true&"
import script from "./reservoir_area.vue?vue&type=script&lang=js&"
export * from "./reservoir_area.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e4b5f2",
  null
  
)

export default component.exports